import React from "react";
import { Link } from "@reach/router";
import { NotFoundStyled } from "./NotFoundStyled";
var NotFound = function () {
    return (React.createElement(NotFoundStyled, null,
        React.createElement("h2", null, "Sorry the page you're looking for cannot be found."),
        React.createElement("p", null,
            React.createElement("strong", null,
                "Back to the ",
                React.createElement(Link, { to: "/directory" }, "homepage"),
                "."))));
};
export default NotFound;
//# sourceMappingURL=NotFound.js.map